const FilterIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="1.56445" width="7.82591" height="2.34777" fill="#FFB800" />
      <rect y="14.0869" width="3.13036" height="2.34777" fill="#FFB800" />
      <rect y="7.82617" width="10.9563" height="2.34777" fill="#FFB800" />
      <rect
        x="13.3041"
        y="1.56445"
        width="6.26073"
        height="2.34777"
        fill="#FFB800"
      />
      <rect
        x="9.39111"
        y="14.0869"
        width="10.1737"
        height="2.34777"
        fill="#FFB800"
      />
      <rect
        x="17.217"
        y="7.82617"
        width="2.34777"
        height="2.34777"
        fill="#FFB800"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.99974 5.47814C10.5125 5.47814 11.7388 4.25182 11.7388 2.73907C11.7388 1.22632 10.5125 0 8.99974 0C7.487 0 6.26067 1.22632 6.26067 2.73907C6.26067 4.25182 7.487 5.47814 8.99974 5.47814ZM8.99978 3.91257C9.6481 3.91257 10.1737 3.38701 10.1737 2.73869C10.1737 2.09037 9.6481 1.5648 8.99978 1.5648C8.35146 1.5648 7.82589 2.09037 7.82589 2.73869C7.82589 3.38701 8.35146 3.91257 8.99978 3.91257ZM5.08682 16.4348C5.73514 16.4348 6.26071 15.9092 6.26071 15.2609C6.26071 14.6126 5.73514 14.087 5.08682 14.087C4.4385 14.087 3.91294 14.6126 3.91294 15.2609C3.91294 15.9092 4.4385 16.4348 5.08682 16.4348ZM14.0866 8.9998C14.0866 9.64812 13.5611 10.1737 12.9127 10.1737C12.2644 10.1737 11.7388 9.64812 11.7388 8.9998C11.7388 8.35148 12.2644 7.82591 12.9127 7.82591C13.5611 7.82591 14.0866 8.35148 14.0866 8.9998ZM7.82592 15.2613C7.82592 16.774 6.59959 18.0004 5.08685 18.0004C3.5741 18.0004 2.34778 16.774 2.34778 15.2613C2.34778 13.7485 3.5741 12.5222 5.08685 12.5222C6.59959 12.5222 7.82592 13.7485 7.82592 15.2613ZM12.9127 11.7383C14.4254 11.7383 15.6518 10.512 15.6518 8.99923C15.6518 7.48648 14.4254 6.26016 12.9127 6.26016C11.4 6.26016 10.1736 7.48648 10.1736 8.99923C10.1736 10.512 11.4 11.7383 12.9127 11.7383Z"
        fill="#FFB800"
      />
    </svg>
  );
};
export default FilterIcon;
